"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cache = exports.CacheableResult = exports.CacheForTime = void 0;
var web_ui_framework_1 = require("@gruposantander/web-ui-framework");
Object.defineProperty(exports, "CacheForTime", { enumerable: true, get: function () { return web_ui_framework_1.CacheForTime; } });
Object.defineProperty(exports, "CacheableResult", { enumerable: true, get: function () { return web_ui_framework_1.CacheableResult; } });
Object.defineProperty(exports, "Cache", { enumerable: true, get: function () { return web_ui_framework_1.Cache; } });
//# sourceMappingURL=index.js.map